import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import PickSocialAccountsModal from './PickSocialAccountsModal';

class SocialAccountsModal extends React.Component {
    constructor() {
        super();
        this.domNode = document.getElementById('social-accounts-modal');
    }

    pickModalByType(modalType) {
        const {
            onCloseModal,
            items,
            linkedItems,
            onSubmit,
            isSubmitting,
        } = this.props;
        switch (modalType) {
            case 'pick-instagram-accounts':
                return (
                    <PickSocialAccountsModal
                        onClose={onCloseModal}
                        onSubmit={onSubmit}
                        items={items}
                        linkedItems={linkedItems}
                        isSubmiting={isSubmitting}
                        title="Select Instagram Account(s)"
                        emptyMsg="No Instagram Account(s) Available, make sure
                        you have a instagram business account linked
                        to a facebook page"
                    />
                );
            case 'pick-facebook-page':
                return (
                    <PickSocialAccountsModal
                        onClose={onCloseModal}
                        onSubmit={onSubmit}
                        items={items}
                        linkedItems={linkedItems}
                        isSubmiting={isSubmitting}
                        title="Select Facebook Page(s)"
                        emptyMsg="No Facebook Page(s) Available, make sure you
                        have a facebook page linked to your account."
                    />
                );
            default:
                return null;
        }
    }

    render() {
        return ReactDOM.createPortal(
            this.pickModalByType(this.props.modal),
            this.domNode,
        );
    }
}

SocialAccountsModal.propTypes = {
    onCloseModal: PropTypes.func.isRequired,
    linkedItems: PropTypes.array.isRequired,
    items: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    modal: PropTypes.string,
    isSubmitting: PropTypes.bool.isRequired,
};

export default SocialAccountsModal;
